/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConIndustryTrackWebControllerV1OneTrackListUsingGet1Params,
  ResultPageResultConIndustryWebWebV1OneTrackResponse,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class ConIndustryTrackWebController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags con-industry-track-web-controller
   * @name ConIndustryTrackWebControllerV1OneTrackListUsingGet1
   * @summary 根据行业编号查询一级赛道
   * @request GET:/consumebrand/web/v1/conindustrytrack/one_track_list
   * @secure
   */
  conIndustryTrackWebControllerV1OneTrackListUsingGet1 = (
    query: ConIndustryTrackWebControllerV1OneTrackListUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultPageResultConIndustryWebWebV1OneTrackResponse, void>({
      path: `/consumebrand/web/v1/conindustrytrack/one_track_list`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
